import { GradientScrollDiv } from '@components/util/GradientScrollDiv';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Modal } from '@mui/material';
import classNames from 'classnames';
import { ReactNode } from 'react';
import css from './MobileModal.module.scss';

type MobileModalProps = {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  contentClassName?: string;
  noBorderBottom?: boolean;
  /** Skip the built-in GradientScrollDiv — use when the consumer manages its own scrolling */
  rawContent?: boolean;
};

export const MobileModal = ({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,
  contentClassName,
  noBorderBottom,
  rawContent,
}: MobileModalProps) => {
  return (
    <Modal open={open} onClose={onClose} keepMounted={false}>
      <div className={css.modal} onClick={(e) => e.stopPropagation()}>
        <div className={classNames(css.header, { [css.noBorderBottom]: noBorderBottom })}>
          <div className={css.headerText}>
            {typeof title === 'string' ? <h2 className={css.title}>{title}</h2> : title}
            {subtitle && <span className={css.subtitle}>{subtitle}</span>}
          </div>
          <IconButton onClick={onClose} size="small" sx={{ color: 'white' }}>
            <CloseIcon />
          </IconButton>
        </div>

        {rawContent ? (
          <div className={classNames(css.content, css.contentRaw, contentClassName)}>
            {children}
          </div>
        ) : (
          <GradientScrollDiv
            className={classNames(css.content, contentClassName)}
            innerDivClassName={css.contentInner}
          >
            {children}
          </GradientScrollDiv>
        )}

        {footer && <div className={css.footer}>{footer}</div>}
      </div>
    </Modal>
  );
};
